var Handlebars = require('/builds/lp-digital/backbee/toolbar-legacy/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div>\n    <div class=\"row\">\n        <div class=\"col-12 search-wrapper\"></div>\n    </div>\n</div>\n";
},"useData":true});